import * as Backbone from "backbone-associations";
import { prop } from "../../decorators/property";
import {WelcomeListCollection} from "../../search/collections/welcome-list";

export class NoResultsModel extends Backbone.AssociatedModel {

    @prop() public Heading = "";
    @prop() public ErrorMessage = "";
    @prop() public IsError: boolean;
    @prop() public Query = "";
    @prop() public MarkedUpQuery = "";
    @prop() public ShowPreviousSearches: boolean;
    @prop() public TitleCorrection: string;
    @prop() public RecentSearches: WelcomeListCollection;
    @prop() public ResultsOutsideJurisdictionSettings: number;
    @prop() public JurisdictionsMessage: string;
    @prop() public JurisdictionList: string[];
    @prop() public ProductList: string[];
    @prop() public LuceneOutputText: string;

    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/no-results.ts